import { FormField } from "@babackapp/ui/components/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@babackapp/ui/components/select";
import { useTranslation } from "react-i18next";
import { useWorkflowForm } from "../../context/workflows-editor-workflows-context";
import { useNodeFormPath } from "../../hooks/use-node-form-path";
import { PanelContent } from "../../lib/panel/panel-content";

export function PanelEmailRecipient() {
  const form = useWorkflowForm();
  const fieldPath = useNodeFormPath("config.recipient");
  const { t } = useTranslation("trackoffice");

  if (!fieldPath) {
    return null;
  }

  return (
    <PanelContent
      title={t("workflowsEditor.panels.emailRecipient.title")}
      description={t("workflowsEditor.panels.emailRecipient.description")}
    >
      <FormField
        control={form.control}
        name={fieldPath}
        render={({ field }) => {
          return (
            <Select
              defaultValue="customer"
              value={field.value as string}
              onValueChange={field.onChange}
            >
              <SelectTrigger className="w-[200px] h-8 text-xs">
                <SelectValue placeholder={t("workflowsEditor.panels.emailRecipient.placeholder")} />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="customer">{t("workflowsEditor.panels.emailRecipient.options.customer")}</SelectItem>
                <SelectItem value="gift-recipient">
                  {t("workflowsEditor.panels.emailRecipient.options.giftRecipient")}
                </SelectItem>
                <SelectItem value="merchant">{t("workflowsEditor.panels.emailRecipient.options.merchant")}</SelectItem>
              </SelectContent>
            </Select>
          );
        }}
      />
    </PanelContent>
  );
}
